import { styled } from '@mui/material';

const PREFIX = 'LogoutButton';

export const logoutBtnClasses = {
  logoutBtn: `${PREFIX}-logoutBtn`,
};

export const LogoutRoot = styled('div')(() => ({
  [`&.${logoutBtnClasses.logoutBtn}`]: {
    textAlign: 'right',
    marginTop: '1.5em',
    '& button': {
      fontSize: '0.875rem',
    },
  },
}));
